<template>
  <div class="padding-10">
    <Header v-if="isAdmin" />
    <Table />
  </div>
</template>

<script>
import Header from "../components/users/Toolbar";
import Table from "../components/users/Table";
export default {
  components: {
    Header,
    Table
  }
};
</script>

<style></style>
